<template>
  <div class='wrapper-page all-checklists'>
    <div class='container-fluid'>
      <h1 class='page-title'>
        {{ $t('folders_list.shared_with_me') }}

        <a :href="sharingVideo" target="_blank" class="own-tooltip own-tooltip-bottom video-link" :data-tooltip="$t('folders_list.click_here_to_watch_shared')">
          <img src="../assets/video.svg" />
        </a>
      </h1>

      <div class='clearfix'></div>

      <div class="nav-tabs-wrapper">
        <ul role="tablist" class="nav nav-tabs">
          <li class="nav-item">
            <router-link :to="{ name: 'shared_folder_index'}" class="nav-link show">
              {{ $t('root.contents') }}
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="{ name: 'shared_folder_index_checklist'}" class="nav-link active show">
              {{ $t('root.all_checklists') }}
            </router-link>
          </li>
        </ul>
      </div>

      <div class="tab-content">
        <div class="checklist-status-wrapper">
          {{ $t('checklist.all_completeness') }}
          <checklist-progress :items-count="totalChecklistItemsLength" :completed-items-count="completedItemsLength" />
        </div>

        <form @submit.prevent='search'>
          <div class="search-container-wrapper">
            <input type="text" name="search" :value="query['filters[content_cont]']" autocomplete="off" placeholder="Search on Checklist" class="form-control search-field" />
            <button type="submit">
              <i class="fas fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </form>

        <div class="dropdown">
          <div class="btn-group float-right show-hide-columns m-r-10" role="group" v-click-outside="closeShowColumnsDropdown" >
            <button class="btn btn-neutral dropdown-toggle" @click.prevent="showColumnsDropdown = !showColumnsDropdown">
              {{$t('records_list.show_hide') }}
            </button>

            <ul class="dropdown-menu" v-show="showColumnsDropdown">
              <li class="dropdown-item" @click="toggleColumns('document_types')">
                <input type="checkbox" :checked="enabledColumns['document_types']" />
                {{$t('checklist.headers.document_type')}}
              </li>
              <li class="dropdown-item" @click="toggleColumns('products')">
                <input type="checkbox" :checked="enabledColumns['products']" />
                {{$t('checklist.headers.products')}}
              </li>
              <li class="dropdown-item" @click="toggleColumns('files')">
                <input type="checkbox" :checked="enabledColumns['files']" />
                {{$t('checklist.headers.files')}}
              </li>
              <li class="dropdown-item" @click="toggleColumns('folder')">
                <input type="checkbox" :checked="enabledColumns['folder']" />
                {{$t('checklist.headers.folder_name')}}
              </li>
              <li class="dropdown-item" @click="toggleColumns('contact')">
                <input type="checkbox" :checked="enabledColumns['contact']" />
                {{$t('checklist.headers.contact_name')}}
              </li>
              <li>
                <button class="btn btn-primary float-right m-r-10" @click="closeShowColumnsDropdown">
                  {{ $t('records_list.table.save') }}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <filter-list />

        <filter-list-from-params />

        <div v-if="loading" class="text-center">
          <loading class="m-t-60"/>
        </div>

        <div class="empty-list-wrapper" v-else-if='hasFilters && checklistItems.length === 0'>
          <img src="../assets/empty_states/records.png" alt="files"/>
          <p>{{ $t('root.no_data_filters') }}</p>
          <router-link :to='{ query: {} }'>
            {{ $t('root.clear_filters') }}
          </router-link>
        </div>

        <div v-else-if="!hasFilters && checklistItems.length === 0" class="empty-list-wrapper">
          <img src="../assets/empty_states/checklist.png" alt="checklist"/>
          <p>
            {{ $t('checklist.empty') }}
            <br/>
            {{ $t('checklist.adding_items') }}
          </p>
        </div>

        <div class="table_wrapper" v-else>
          <table class="table checklist-table">
            <thead>
              <tr>
                <th v-show="enabledColumns['document_types']" class="visible">
                  <router-link :to="addToQuery({ 'filters[s]': sortBy('document_type_name') })">
                    {{ $t('checklist.headers.document_type') }}
                    <span :class="classSortDirection('document_type_name')"></span>
                  </router-link>
                </th>
                <th v-show="enabledColumns['products']">
                  <router-link :to="addToQuery({ 'filters[s]': sortBy('product_name') })">
                    {{ $t('checklist.headers.products') }}
                    <span :class="classSortDirection('product_name')"></span>
                  </router-link>
                </th>
                <th v-show="enabledColumns['files']">
                  <router-link :to="addToQuery({ 'filters[s]': sortBy('record_filename') })">
                    {{ $t('checklist.headers.files') }}
                    <span :class="classSortDirection('record_filename')"></span>
                  </router-link>
                </th>
                <th v-show="enabledColumns['folder']">
                  <router-link :to="addToQuery({ 'filters[s]': sortBy('folder_name') })">
                    {{ $t('checklist.headers.folder_name') }}
                    <span :class="classSortDirection('folder_name')"></span>
                  </router-link>
                </th>
                <th v-show="enabledColumns['contact']">
                  <router-link :to="addToQuery({ 'filters[s]': sortBy('folder_user_full_name') })">
                    {{ $t('checklist.headers.contact_name') }}
                    <span :class="classSortDirection('folder_user_full_name')"></span>
                  </router-link>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="item in checklistItems" :key="item.id" class="list-item">
                <td class="checklist-content-column" v-show="enabledColumns['document_types']">
                  <div class="document-type-bubble">
                    {{ item.document.name }}
                  </div>
                </td>
                <td class="checklist-content-column" v-show="enabledColumns['products']">
                  <div class="product-bubble">
                    {{ item.product.name }}
                  </div>
                </td>
                <td v-show="enabledColumns['files']">
                  <div v-if='item.record.id'>
                    <b>{{ $t('checklist.uploaded_file') }}</b>

                    <router-link :to="{ name: 'shared_record_show', params: { id: item.record.id } }" class='file-link'>
                      {{ item.record.name }}
                    </router-link>

                    <br/>

                    <div class="exp-status">
                      <span :class='item.record.status'>{{ expStatusTranslations[item.record.status] }}</span>
                    </div>
                  </div>
                  <p v-else>{{ $t('checklist.no_file') }}</p>
                </td>
                <td v-show="enabledColumns['folder']">
                  <router-link :to="{name: 'shared_folder_show', params: { id: item.folder.id }}">
                    {{ item.folder.name }}
                  </router-link>
                </td>
                <td v-show="enabledColumns['contact']">
                  {{ item.contact.name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination :meta='meta' />
      </div>
    </div>
  </div>
</template>

<script>
  import _loading from '../components/_loading'
  import _pagination from '../components/_pagination'

  import _folder_form from '../components/shared/folders/_folder_form'
  import _folder_settings from '../components/shared/folders/_settings'
  import _upload_to_folder_form from '../components/shared/folders/_upload_form'
  import _subscribe_to_folder_form from '../components/folders/_subscription_modal'

  import _copy_items_to_folder_modal from '../components/checklists/_copy_items_to_folder_modal'
  import _move_items_to_folder_modal from '../components/checklists/_move_items_to_folder_modal'
  import _delete_checklist_items_modal from '../components/checklists/_delete_checklist_items_modal'
  import _hide_show_checklist_items_modal from '../components/checklists/_hide_show_checklist_items_modal'
  import _checklist_progress from '../components/checklists/_status'

  import _filter_list from '../components/filters/sharing/_filter_list_for_shared_with_me'
  import _filter_list_from_params from '../components/filters/sharing/_filter_list_from_params'

  export default {
    components: {
      loading: _loading,
      pagination: _pagination,

      'subscribe-to-folder-form': _subscribe_to_folder_form,
      'folder-form': _folder_form,
      'folder-settings': _folder_settings,
      'upload-to-folder-form': _upload_to_folder_form,

      'checklist-progress': _checklist_progress,
      'copy-items-to-folder-modal': _copy_items_to_folder_modal,
      'move-items-to-folder-modal': _move_items_to_folder_modal,
      'delete-checklist-items-modal': _delete_checklist_items_modal,
      'hide-show-checklist-items-modal': _hide_show_checklist_items_modal,

      'filter-list': _filter_list,
      'filter-list-from-params': _filter_list_from_params
    },
    data() {
      return {
        loading: false,
        showColumnsDropdown: false,
      }
    },
    created() {
      this.loadChecklist()
    },
    watch: {
      query() {
        this.loadChecklist()
      },
    },
    computed: {
      checklistItems() {
        return Object.freeze(this.state.sharedChecklistItems || [])
      },
      checklistColumns() {
        return Object.freeze(this.userDefaults['folder_checklist'] || [])
      },
      enabledColumns() {
        const cols = {}
        this.checklistColumns.forEach(c => cols[c] = true)
        return Object.freeze(cols)
      },
      checklistItemStats() {
        return this.stats.sharedChecklistItems || {}
      },
      totalChecklistItemsLength() {
        return this.checklistItemStats.total
      },
      completedItemsLength() {
        return this.checklistItemStats.checked
      },
      sharingVideo(){
        return this.locale == 'de' ? 'https://relatico.wistia.com/medias/xhozew4cxg' : 'https://relatico.wistia.com/medias/71s8nxqnzi'
      },
    },
    methods: {
      loadChecklist() {
        const params = Object.assign({}, this.query)

        this.loading = true
        this.store.getSharedChecklistItems(params).then(() => {
          this.loading = false
          this.statStore.getSharedChecklistItems(params)
        })
      },
      toggleColumns(column) {
        const newColumns = new Set(this.checklistColumns)
        this.enabledColumns[column] ? newColumns.delete(column) : newColumns.add(column)

        const params = {
          user: {
            defaults: Object.assign({}, this.userDefaults, { folder_checklist: Array.from(newColumns) })
          }
        }

        this.store.updateUserProfile(params).then(() => {
          this.store.sendMetrics({name: 'toggle_columns_checklist', params: this.$route.params, path: this.$route.fullPath})
          this.store.getCurrentUser()
        })
      },
      closeShowColumnsDropdown() {
        this.showColumnsDropdown = false
      },
      search(e) {
        const q = new FormData(e.target).get('search')
        if (q && q.length > 0)
          this.$router.push({ query: Object.assign({}, this.query, { 'filters[content_cont]': q })})
      },
    }
  }
</script>

<style lang="sass" scoped>
  .filter
    display: flex
    margin-top: 20px
    .default-filters
      .dropdown
        > button
          background: none
          border: none
      .form-group
        margin-bottom: 0
        margin-right: 15px
  .checklist-status-wrapper
    font-size: 16px
    margin-bottom: 20px
  .checklist-table
    .fa-check
      font-size: 18px
      padding-top: 15px
    .sharing-visibility
      margin-top: 0
      .checkmark
        background: transparent
        font-size: 20px
        width: auto
        height: auto
        &:hover
          background: transparent
      &.checkbox-container input:checked ~ .checkmark
        background: transparent
        &:after
          display: none
        &:before
          content: "\f06e"
  .search-container-wrapper
    display: flex
    width: 40%
    float: right
    input
      padding-left: 5px
      border: 1px solid #b4b4b4
      border-right: none
      height: 43px
      font-size: 14px
    button
      border: .5px solid #b4b4b4
      padding: 8px 8px 7px
      cursor: pointer
      border-radius: 0 6px 6px 0
      color: #b4b4b4
      border-left: none
      margin-left: -3px
    i.fa-search
      left: 9px
      top: 13px
      font-size: 18px
      position: initial
</style>
